
;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.TippingLeaguesCoaches = View.ExtendedLeaguesCoaches.extend({
		template: JST.ExtendTippingLeaguesCoachesForION,
		canMakeAdmin: false,
		canRemoveUser: true,
		canMakePaid: false
	});

}(window, APP, Backbone, Marionette, $, _));